import superJSON from 'superjson';

export const transformer = superJSON;
